import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';

export class SettingsService {
  fetch(settingId: number) {
    return useCaller(RequestProxy.LS_AXON, RequestName.FETCH_SETTINGS, `company_settings`, RequestMethod.GET, {
      setting_id: settingId,
    });
  }
}
